import { Helmet } from "react-helmet";
import StylishBanner from "../components/Reusable Elements/StylishBanner";
import InfoAndSlideShow from "../components/Sections/InfoAndSlideShow";
import ProjectLocation from "../components/Sections/ProjectLocation";
import FullGallery from '../components/Sections/FullGallery'
import Button from "../components/Reusable Elements/Button";
import PaymentPlans from "../components/Sections/PaymentPlans";

const PearlResidencia = () => {
    return (
        <div style={{ paddingTop: "99px" }}>
            <Helmet>
                <title>Pearl Residencia</title>
            </Helmet>
            <StylishBanner heading="Welcome to Pearl Residencia" number={3} />
            <div className="font-poppins text-2xl text-primary-blue font-extralight text-center sm:px-40 px-8 py-20">
                Where affordable luxury meets family living, offering privacy
                and security in an 18-Kanal gated community lush with greenery
                and modern designs. All in a well-connected LDA approved
                location in Lahore.
            </div>
            <InfoAndSlideShow section={7} />
            <InfoAndSlideShow section={8} />
            <ProjectLocation />
            <PaymentPlans background={"light"}/>
            <div className="text-primary-blue text-5xl font-extralight font-poppins text-center pt-10">
                Overview
            </div>
            <FullGallery variant={2} />
            <div className="flex justify-center pb-12 mt-[-30px]">
                <Button
                    text={"See More"}
                    color={"#ffffff"}
                    location={"/gallery"}
                />
            </div>
        </div>
    );
};

export default PearlResidencia;
